import { render, staticRenderFns } from "./Catalogo.vue?vue&type=template&id=7a2f45b0&scoped=true&"
import script from "./Catalogo.vue?vue&type=script&lang=js&"
export * from "./Catalogo.vue?vue&type=script&lang=js&"
import style0 from "./Catalogo.vue?vue&type=style&index=0&id=7a2f45b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2f45b0",
  null
  
)

export default component.exports